import {AssignmentStatuses, TaskStatusIds} from '../../../util/uiconstants';
import * as actionTypes from '../../../actions/actiontypes';
import initialstate from '../../initialstate';

export function aresTaskDetailsReducer(state = initialstate.aresTaskDetails, action) {
	let newState;

	switch (action.type) {
		case actionTypes.ARES_GET_TASK_BY_ID: {
			if (action.response && !action.error) {
				// Assignments do not come from the get task by id api call, so we need to keep the store assignments.
				const stateAssignments = state[action.taskId.toLowerCase()]?.assignments || [];

				newState = {
					...state,
					[action.taskId.toLowerCase()]: {
						...state[action.taskId.toLowerCase()],
						...action.response,
						name: action.response.taskName,
						assignments: stateAssignments,
						id: action.taskId.toLowerCase(),
						isTaskById: true
					}
				};
			}
			break;
		}
		case actionTypes.GET_TASK_ASSIGNMENTS: {
			if (action.error) {
				return state;
			}

			const taskAssignments = state[action.taskId]?.assignments || [];
			const taskStatusId = state[action.taskId]?.statusId;

			//TODO (discuss with Shane after release 2.11.0): We shouldn't have an if statement to manage assignments from different sources. We need to centralize it.
			//The first if statement handles the assignments which come from the task get all api call.
			//The second if statement handles the assignments which come from the task get assignments call (we don't do a get all task api call, we do the get all task overview which doesn't bring assignments today).
			//I believe we should just stick with the get all assignments call and not get them from different api calls using flags to include them. We should stick with the one at resource level.
			//We can't keep on having different data treatment depending on which api call you are coming from, it's hard to maintain and not scalable.
			const assignments =
				taskAssignments.length > 0
					? taskAssignments.map((assignment) => {
							const _assignment = action?.response?.reviewersList.find(
								(a) =>
									(a.assignmentId === assignment.assignmentId || a.assignmentId === assignment.id) &&
									a.taskAssignmentId === assignment.taskAssignmentId &&
									(a.assignedToUserId === assignment.assignedToUserId ||
										a.assignedToRoleId === assignment.assignedToRoleId)
							);

							return {
								...assignment,
								assignmentStatusId: applyAssignmentStatusId(_assignment, taskStatusId),
								modifiedByFirstName: _assignment.modifiedByFirstName,
								modifiedByLastName: _assignment.modifiedByLastName,
								modifyDate: _assignment.modifiedByDate,
								isCurrent: _assignment.isCurrent
							};
					  })
					: action?.response?.reviewersList.map((assignment) => {
							return {
								...assignment,
								assignmentStatusId: applyAssignmentStatusId(assignment, taskStatusId),
								taskTimePhase: action?.response.taskTimePhase
							};
					  });

			newState = {
				...state,
				[action.taskId.toLowerCase()]: {
					...state[action.taskId.toLowerCase()],
					assignments
				}
			};
			break;
		}
		default:
			return state;
	}

	return newState || state;
}

function applyAssignmentStatusId(assignment, taskStatusId) {
	let status = AssignmentStatuses.Open;

	if (assignment) {
		if (assignment.isComplete) {
			status = AssignmentStatuses.Complete;
		} else if (taskStatusId && taskStatusId === TaskStatusIds.Open) {
			status = AssignmentStatuses.Open;
		} else if (assignment.isCurrent) {
			status = AssignmentStatuses.InProcess;
		}
	}

	return status;
}
